<template>
    <div class="lg:w-1/2 m-auto">
        <setup-substep name="delivery-substep-1" next-text="Ok, done" next-substep="delivery-substep-2" open>
            <p class="my-2 font-bold">⌚️ All incoming emails will be collected and delivered to you when you're ready to tackle them.</p>
            
            <p class="my-2">Based on your emailing habits, we suggest the following schedule. You can change them now or always do it later in your account.</p>

            <p class="text-gray-darker text-sm">All times are in your local timezone ({{ timezone }} hours).</p>

            <div class="mt-2">
                <div class="rounded bg-gray-light">
                    <div class="flex items-start px-3 py-6">
                        <div class="mx-3 flex-1 -mt-1">
                            <div class="mt-2 flex flex-wrap items-center">
                                <span v-for="(hour, index) in value.hours" :key="index">
                                    <vue-timepicker
                                        format="hh:mma"
                                        placeholder="hh:mm"
                                        :minute-interval="10"
                                        close-on-complete
                                        hour-label="hour"
                                        minute-label="minute"
                                        apm-label=" "
                                        auto-scroll
                                        v-model="hour.raw"
                                    />
                                </span>
                                <button class="bg-primary-lighter text-primary h-8 w-8 rounded-full focus:outline-none active:outline-none" @click="addNewHour">
                                    <font-awesome-icon :icon="['fas', 'plus']"></font-awesome-icon>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </setup-substep>
        
        <setup-substep name="delivery-substep-2" next-text="Setup VIPs →" @completed="done">
            <span class="border-t my-4 border-gray-dark block"></span>

            <p class="mt-4 mb-2"><strong>Delivery slots are set!</strong> But there might be some emails that must be seen immediately. Let's setup VIPs.</p>
        </setup-substep>
    </div>
</template>

<script>
export default {
    id   : 'delivery',
    icon : 'clock',
    label: 'Delivery',

    data() {
        return {
            value     : {
                hours: Schedule.makeRawHours([]),
            },
            utc_offset: new Date().getTimezoneOffset(),
        }
    },

    computed: {
        timezone() {
            let sign = this.utc_offset < 0 ? '+' : '-';
            let absoluteOffset = Math.abs(this.utc_offset);
            let offsetInHours = (absoluteOffset/60);
            
            let hours = (Math.floor(absoluteOffset/60)).toString().padStart(2, '0');
            let minutes = (Math.floor(absoluteOffset%60)).toString().padStart(2, '0');
            
            return `GMT${sign}${hours}:${minutes}`;
        }
    },

    mounted() {
        axios.get(`/api/mailbox`)
            .then((response) => {
                if (response.data.data.schedule.hours) {
                    this.value.hours = Schedule.makeRawHours(response.data.data.schedule.hours);
                } else {
                    this.value.hours = Schedule.makeRawHours(['08:00am', '12.30pm', '04.30pm']);
                }
            })
            .catch(console.error);
    },

    methods: {
        done() {
            axios.put(`/api/mailbox`, {
                schedule: {type: 'hours', hours: Schedule.makeHoursFromRaw(this.value.hours)},
                summary: {
                    state: 'on',
                    at   : '04:30pm',
                },
                dnd: { state: 'off' },
            })
            .then(() => {
                this.$emit('done');
            })
            .catch((err) => {
                console.error(err);
            });
        },
        addNewHour() {
            this.value.hours.push(Schedule.emptyHour());
        },
    }

}
</script>